<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data() {
    return {
      defaultGraphOptions: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [ {
            gridLines: {
              display: false,
            },
          }],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    graphOptions: {
      type: Object,
    },
  },
  mounted() {
    // this.dataOption.data = this.data;
    const dataCollection = {
      labels: this.labels,
      datasets: this.datasets,
    };
    this.renderChart(dataCollection, this.graphOptions ? this.graphOptions : this.defaultGraphOptions);
  },
};
</script>

<style>
</style>